import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const isDevMode =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_PRODUCTION_MODE !== "true";

if (isDevMode) initialState.tenant = { id: 0 };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      return { ...state, user: action.payload };
    },
    setConfigCatUser: (state, action) => {
      return { ...state, configCatUser: action.payload };
    },
    setTenant: (state, action) => {
      return { ...state, tenant: action.payload };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = authSlice;

// Extract and export each action creator by name
export const { setConfigCatUser, setUser, setTenant } = actions;

// Export the reducer, either as a default or named export
export default reducer;
